/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorResponse } from '../api/thunkActionTypes';

export const createAppAsyncThunk = (type: string, thunk: any): any => {
  return createAsyncThunk<any, any, any>(
    type,
    async (arg: any, thunkAPI: any) => {
      try {
        return await thunk(arg, thunkAPI);
      } catch (error: any) {
        const errorResponse: ErrorResponse = {
          data: error.data,
          status: error.status,
          statusText: error.statusText,
        };
        return thunkAPI.rejectWithValue(errorResponse);
      }
    }
  );
};
